"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpisFormProductPackage = void 0;
var centralized_zod_1 = require("@ipis/centralized-zod");
var IpisFormProductPackage;
(function (IpisFormProductPackage) {
    IpisFormProductPackage.Schema = centralized_zod_1.z.object({
        id: centralized_zod_1.z.string(),
        name: centralized_zod_1.z.string(),
        connectedFormId: centralized_zod_1.z.string().nullable(),
    });
})(IpisFormProductPackage || (IpisFormProductPackage = {}));
exports.IpisFormProductPackage = IpisFormProductPackage;
